import React from 'react'
import numbro from 'numbro';
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";

// Core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import dashGeneralPageStyle from "assets/jss/prehnit/views/dashGeneralPageStyle.jsx";

import { withNamespaces } from "react-i18next";

import { Context } from "Context.jsx";

//import { API } from "services/api";
import i18n from "i18next";

import * as ExcelJs from 'exceljs/dist/exceljs.js';
import createReport from 'docx-templates';
//import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'file-saver';

function sortTrendsData(a, b) {
  if (a.y !== b.y) {
    return b.y - a.y
  } else {
    if (a.id !== b.id) {
      return a.id - b.id
    } else {
      return a.k3 - b.k3;
    }
  }
}

class CLCExportCard extends React.Component {

  constructor(props) {
    super(props);

    this.handleExcel = this.handleExcel.bind(this);
    this.handleWord = this.handleWord.bind(this);
    this.genFileName = this.genFileName.bind(this);
    this.genTableData = this.genTableData.bind(this);
    this.saveDataToFile = this.saveDataToFile.bind(this);
    this.getTitle = this.getTitle.bind(this);
  }

  genReportName(reportType, lng) {
    return "/templates/report_template_" + reportType + "_" + lng + ".docx";
  }

  genFileName(unit, ext) {
    return "clccro_" + this.props.categoryCode
      + (this.props.regionOne ? "_" + this.props.regionOne : "")
      + (this.props.regionTwo ? "_" + this.props.regionTwo : "")
      + "_" + unit
      + "_" + i18n.language + "." + ext;
  }

  genTableData(unit) {
    const { t } = this.props;

    let data1 = this.props.allData;
    let data2 = this.props.allData

    if (!this.props.single) {
      data1 = this.props.allData.filter(x => x['id'] == this.props.regionOne);
      data2 = this.props.allData.filter(x => x['id'] == this.props.regionTwo);
    }


    let elements = [];
    let elementsHash = {};

    for (let i = 0; i < data1.length; i++) {
      let code = data1[i].kod_3;
      if (!elementsHash[code]) {
        elements.push(data1[i]);
        elementsHash[code] = true;
      }
    }

    if (!this.props.single) {
      for (let i = 0; i < data2.length; i++) {
        let code = data2[i].kod_3;
        if (!elementsHash[code]) {
          elements.push(data2[i]);
          elementsHash[code] = true;
        }
      }
    }

    let sorted_elements = elements.sort(this.props.sortFunc);

    let tableData = [];

    for (let i = 0; i < sorted_elements.length; i++) {
      let row = {};
      let code = sorted_elements[i].kod_3;
      row['code'] = code;
      row['title'] = t("clc:" + code)

      // let val1 = this.filterData(data1, 'kod_3', code)
      let val1 = data1.filter(x => x['kod_3'] == code);
      if (val1.length > 0) {
        row['area_a'] = numbro(unit.transform(val1[0]['pov_3_ha'] * 100)).divide(100).format()
      } else {
        row['area_a'] = '--';
      }

      if (!this.props.single) {
        // let val2 = this.filterData(data2, 'kod_3', code)
        let val2 = data2.filter(x => x['kod_3'] == code);
        if (val2.length > 0) {
          row['area_b'] = numbro(unit.transform(val2[0]['pov_3_ha'] * 100)).divide(100).format();
        } else {
          row['area_b'] = "--";
        }
      }

      tableData.push(row);
    }

    return tableData;
  }

  genMapImage(mapId) {
    let el = document.getElementById(mapId);
    if (el) {
      let width = el.offsetWidth;
      let height = el.offsetHeight;
      let ratio = width / height;

      let canvases = el.getElementsByTagName('canvas');
      let canvas = canvases[0];

      let png = canvas.toDataURL("image/png");
      return png;
    } else {
      console.warn('Cannot find map with id: ', mapId);
      return null;
    }
  }

  genChartImage(chartId, callback) {
    let el = document.getElementById(chartId);
    let width = el.offsetWidth;
    let height = el.offsetHeight;
    let ratio = width / height;
    let svgs = el.getElementsByTagName('svg')
    let svg = svgs[0];

    var svgString = new XMLSerializer().serializeToString(svg);

    var svg64 = btoa(svgString);
    var b64Start = 'data:image/svg+xml;base64,';
    var image64 = b64Start + svg64;

    let img = new Image();

    img.setAttribute('crossOrigin', 'anonymous');
    img.width = el.offsetWidth;
    img.height = el.offsetHeight;

    img.onload = function () {
      let canvas = document.createElement('canvas');
      canvas.width = el.offsetWidth;
      canvas.height = el.offsetHeight;
      let ctx = canvas.getContext("2d");

      ctx.drawImage(img, 0, 0);

      let png = canvas.toDataURL("image/png")

      callback(png, ratio)
    };

    img.onerror = function () {
      console.warn("Error loading image:", chartId);
    }

    img.src = image64;

    return;
  }

  getTitle(data, id) {
    const { t } = this.props;

    let filteredData = data.filter(x => x.id == id);
    if (filteredData && filteredData.length > 0) {
      const el = filteredData[0];
      if (el.title_trans_token) {
        return t(el.title_trans_token);
      } else {
        return el.title || null;
      }
    } else {
      return null;
    }
  }

  handleExcel(unit) {
    const { t } = this.props;
    var workbook = new ExcelJs.Workbook();

    var worksheet = workbook.addWorksheet('Data', { views: [{ xSplit: 1, ySplit: 1 }] });

    let columns = [
      { header: t("export:col-year"), key: 'year', width: 10, style: { alignment: { horizontal: 'center' } } },
      { header: t("export:col-clc1-code"), key: 'clc1Code', width: 10, style: { alignment: { horizontal: 'center' } } },
      { header: t("export:col-clc1-title"), key: 'clc1Title', width: 32 },
      { header: t("export:col-clc1-area") + ' / ' + unit.short, key: 'clc1Area', width: 17, style: { numFmt: '0.00' } },
      { header: t("export:col-clc3-code"), key: 'clc3Code', width: 10, style: { alignment: { horizontal: 'center' } } },
      { header: t("export:col-clc3-title"), key: 'clc3Title', width: 50 },
      { header: t("export:col-clc3-area") + ' / ' + unit.short, key: 'clc3Area', width: 17, style: { numFmt: '0.00' } }
    ];

    if (!this.props.single) {
      columns.push(
        { header: t("export:col-region-title"), key: 'regionTitle', width: 32 }
      );
    }

    worksheet.columns = columns;

    let titles = [];
    let data = [];
    if (this.props.hasFilter) {
      titles = this.props.allData.filter(x => x['id'] == this.props.regionOne || x['id'] == this.props.regionTwo).map(function (x) {
        return { id: x.id, title: x.title_trans_token.length > 0 ? t(x.title_trans_token) : x.title }
      });

      data = this.props.trendsData.filter(x => x['id'] == this.props.regionOne || x['id'] == this.props.regionTwo).sort(sortTrendsData)
    } else {
      titles = this.props.allData.map(function (x) {
        return { id: x.id, title: x.title_trans_token.length > 0 ? t(x.title_trans_token) : x.title }
      });
      data = this.props.trendsData.sort(sortTrendsData)
    }

    data.forEach(function (row) {

      let regionTitle = "";
      let regionTitles = titles.filter(function (x) { return x.id === row.id })
      if (regionTitles && regionTitles.length > 0) {
        regionTitle = regionTitles[0].title;
      }

      let excelRow = {
        year: row.y,
        clc1Code: row.k1,
        clc1Title: t("clc:" + row.k1),
        clc1Area: numbro.unformat(numbro(unit.transform(row.p1 * 100)).divide(100).format()),
        clc3Code: row.k3,
        clc3Title: t("clc:" + row.k3),
        clc3Area: numbro.unformat(numbro(unit.transform(row.p3 * 100)).divide(100).format())
      }

      if (!this.props.single) {
        excelRow['regionTitle'] = regionTitle;
      }
      worksheet.addRow(excelRow);

    }.bind(this));

    let filename = this.genFileName(unit.short, 'xlsx');

    workbook.xlsx.writeBuffer().then(function (data) {
      var blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      saveAs(blob, filename);
    });
  }

  loadWordTemplate(url, callback) {
    JSZipUtils.getBinaryContent(url, callback)
  }

  readFileIntoArrayBuffer = fd =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsArrayBuffer(fd);
    });

  saveDataToFile(data, fileName, mimeType) {
    const blob = new Blob([data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    this.downloadURL(url, fileName, mimeType);
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);
  };

  downloadURL(data, fileName) {
    const a = document.createElement('a');
    a.href = data;
    a.download = fileName;
    document.body.appendChild(a);
    a.style = 'display: none';
    a.click();
    a.remove();
  };

  fillReport(content, unit, imagesData) {
    const { t } = this.props;
    let tblData = this.genTableData(unit);

    let regionOneData = this.props.allData.filter(x => x.id == this.props.regionOne);
    let regionTwoData = this.props.allData.filter(x => x.id == this.props.regionTwo);

    let regionOneStats = undefined;
    let regionTwoStats = undefined;
    if (this.props.statsData) {
      regionOneStats = this.props.statsData.filter(x => x.region_code == this.props.regionOne)[0];
      regionTwoStats = this.props.statsData.filter(x => x.region_code == this.props.regionTwo)[0];
    }


    const report = createReport({
      template: content,
      data: {
        all: tblData,
        unit: unit.short,
        area: 1,
        clc3_count: tblData.length,
        date: (new Date()).toLocaleDateString(i18n.language),
        region_type: t('export:' + this.props.categoryCode),
        primary: {
          title: this.getTitle(this.props.allData, this.props.regionOne),
          code: this.props.regionOne || "",
          area: regionOneStats ? numbro(unit.transform(regionOneStats.region_area_ha * 100)).divide(100).format() : '',
          rel_area: regionOneStats ? regionOneStats.region_perc : '',
          clc3_count: regionOneData.length
        },
        secondary: {
          title: this.getTitle(this.props.allData, this.props.regionTwo),
          code: this.props.regionTwo || "",
          area: regionTwoStats ? numbro(unit.transform(regionTwoStats.region_area_ha * 100)).divide(100).format() : '',
          rel_area: regionTwoStats ? regionTwoStats.region_perc : '',
          clc3_count: regionTwoData.length
        }
      },
      additionalJsContext: {
        chart: function (id, width) {
          let chartData = imagesData.filter(x => x.id == id)[0];
          let chartImage = chartData.image;
          let chartRatio = chartData.ratio;

          let height = width / chartRatio;
          const dataUrl = chartImage;
          const data = dataUrl.slice('data:image/png;base64,'.length);
          return { width: width, height: height, data, extension: '.png' }
        },
        map: function (id, width) {
          const dataUrl = this.genMapImage(id);
          const data = dataUrl.slice('data:image/png;base64,'.length);
          return { width: width, height: width, data, extension: '.png' }
        }.bind(this)
      }
    })
    report.then(data => {
      let filename = this.genFileName(unit.short, 'docx');

      this.saveDataToFile(
        data,
        filename,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      );

    })

  }

  handleWord(unit) {
    let templateName = this.genReportName(this.props.reportType, i18n.language);

    this.loadWordTemplate(templateName, function (error, content) {
      if (error) {
        console.warn(error);
        throw error;
      }

      let chartIds = this.props.chartIds;
      let data = [];

      chartIds.forEach(id => this.genChartImage(id, function (png, ratio) {
        let d = {
          id: id,
          image: png,
          ratio: ratio
        };
        data.push(d);
        if (chartIds.length == data.length) {
          this.fillReport(content, unit, data);
        }
      }.bind(this)));
    }.bind(this));
  }

  render() {
    const { t, classes } = this.props;
    return (
      <Card>
        <CardHeader color={this.props.color}>
          <CardIcon color={this.props.color}>
            <Icon>save_alt</Icon>
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            {this.props.title}
            {this.props.subtitle ? <small> - {this.props.subtitle}</small> : null}
          </h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6} lg={6}>
              <Card pricing>
                <CardBody pricing>
                  <h6 className={classNames(classes.cardCategory, classes.cardDescription, classes.marginBottom20)}>{t('common:document')}</h6>
                  <div className={classes.iconWrapper}>
                    <Icon className={classes.iconInfo} >description</Icon>
                  </div>
                  <h3 className={classNames(classes.cardTitle, classes.marginTop30)}>{t('common:word')}</h3>
                  <p className={classes.cardDescription}>{t('common:word-desc')}</p>
                  <Context.Consumer>
                    {ctx =>
                      <Button
                        color="primary"
                        disabled={this.props.reportType !== "all" && this.props.regionOne === undefined}
                        onClick={() => this.handleWord(ctx.unit)}>
                        {t('common:download')}
                      </Button>
                    }
                  </Context.Consumer>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6} lg={6}>
              <Card pricing>
                <CardBody pricing>
                  <h6 className={classNames(classes.cardCategory, classes.cardDescription, classes.marginBottom20)}>{t('common:data')}</h6>
                  <div className={classes.iconWrapper}>
                    <Icon className={classes.iconInfo} >grid_on</Icon>
                  </div>
                  <h3 className={classNames(classes.cardTitle, classes.marginTop30)}>{t('common:excel')}</h3>
                  <p className={classes.cardDescription}>{t('common:excel-desc')}</p>
                  <Context.Consumer>
                    {ctx =>
                      <Button
                        color="primary"
                        disabled={this.props.reportType !== "all" && this.props.regionOne === undefined}
                        onClick={() => this.handleExcel(ctx.unit)} >
                        {t('common:download')}
                      </Button>
                    }
                  </Context.Consumer>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter className={classes.cardFooter}>
        </CardFooter>
      </Card>

    );
  }
}

export default withNamespaces()(withStyles(dashGeneralPageStyle)(CLCExportCard));
